/* eslint-disable no-return-assign */
/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useMutation, useQuery, useReactiveVar } from '@apollo/client';
import {
    Breadcrumb, Button, Panel, SelectTable, Tooltip,
} from 'appkit-react';
import { isEqual } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';

import {
    activeDataReconMenuVar, leftNavigationItemsVar, showDataReconMenusVar, tenantIdVar, currentLeftMenuVar,
} from 'Apollo/config';
import { RUN_FILE_MATCH } from 'Apollo/Mutations';
import { GET_USERS } from 'Apollo/Queries';
import { GET_PROJECT_AND_RECON_CONFIG_DETAILS } from 'Apollo/Queries/DataRecon';
import { ModuleEnum } from 'constants';
import DefaultAlert from 'views/Shared/components/DefaultAlert';
import ErrorView from 'views/Shared/components/ErrorView';
import Loader from 'views/Shared/components/Loader';
import crossReportImg from 'assets/images/cross-report-black.svg';
import AddFilesToProjectModal from './AddFilesToProject/AddFilesToProjectModal';
import './DataLineageUpload.scss';
import DeleteReconFileInfo from './DeleteReconFileInfo/DeleteReconFileInfo';
import UpdateProjectUsers from './UpdateProjectUsers/UpdateProjectUsers';
import UpdateStatus from './UpdateStatus/UpdateStatus';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const DataLineageUpload = () => {
    const history = useHistory();
    const location = useLocation();
    const tenantVar = useReactiveVar(tenantIdVar);
    const [tenantId, setTenantId] = useState(tenantVar);
    const [project, setProject] = useState(location.state.project);

    const [showStatusDropdown, setShowStatusDropdown] = useState(false);
    const [showUsersDropdown, setShowUsersDropdown] = useState(false);

    const [showAddFilesModal, setShowAddFilesModal] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [selection, setSelection] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    let selectTable = useRef();
    const selectType = 'checkbox';
    const keyField = 'fileId';

    const [runFileMatch, { loading: runFileMatchLoading }] = useMutation(RUN_FILE_MATCH);

    /* apollo query to fetch the project users */
    const users = useQuery(GET_USERS, {
        variables: {
            input: {
                tenantId: parseInt(tenantId, 10),
                getAll: true,
            },
        },
    });

    /* apollo query to fetch the project and reconciliation config details
    * based on project selected
     */
    const {
        loading, error, data, refetch,
    } = useQuery(GET_PROJECT_AND_RECON_CONFIG_DETAILS, {
        variables: {
            input: {
                projectId: parseInt(project.projectId, 10),
                parentProjectId: parseInt(project.parentProjectId, 10),
                tenantId: parseInt(tenantId, 10),
            },
        },
        fetchPolicy: 'no-cache',
    });

    let projectDetails;
    if (data && data.getProjectAndReconConfigDetails) {
        projectDetails = data.getProjectAndReconConfigDetails.projectDetails;
    }

    let fileUploadResult;
    if (data && data.getProjectAndReconConfigDetails) {
        fileUploadResult = data.getProjectAndReconConfigDetails.fileInfoArr;
    }

    /* function to navigate to projects page */
    const navigateToProjects = () => history.push(
        {
            pathname: '/Projects',
            state: {
                tenantId,
            },
        },
    );

    /* function to navigate to Data Recon home page */
    const navigateToReconHome = () => history.push(
        {
            pathname: '/data-recon-home',
            state: {
                tenantId,
            },
        },
    );

    /* function to navigate to Reconciliation Config page */
    const navigateToConfigPage = () => history.push(
        {
            pathname: '/dataconfiguration',
            state: {
                projectId: projectDetails && projectDetails.projectId,
                tenantId,
                project,
            },
        },
    );

    /* Breadcrumb items */
    const items = [
        {
            link: '',
            value: <span className="appkiticon icon-home-fill font-16" onClick={navigateToReconHome} role="presentation" />,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text" onClick={navigateToProjects} role="presentation"> Projects </span>,
        },
        {
            link: '',
            value: <span className="a-h6">{projectDetails && projectDetails.projectName}</span>,
        },
    ];

    /* function to get users' names from list of user ids */
    const getUserName = userIds => {
        let names = '';
        if (userIds && userIds.length > 0) {
            userIds.forEach(id => {
                if (users.data) {
                    const result = users.data.getUsers.find(user => user.userId === id);
                    const name = result ? result.fullName : '';
                    names += `${name}, `;
                }
            });
        }
        names = names.trim();
        names = names.slice(0, names.length - 1);
        return names;
    };

    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);

    /* side effect called when location is changed */
    useEffect(() => {
        setTenantId(location.state.tenantId);
        setProject(location.state.project);
        showDataReconMenusVar(true);
        activeDataReconMenuVar('projects');
    }, [location]);

    useEffect(() => {
        setTenantId(tenantVar);
    }, [tenantVar]);
    useEffect(() => {
        refetch();
    }, [tenantId]);

    let existingFiles;
    if (data && data.getProjectAndReconConfigDetails && data.getProjectAndReconConfigDetails.projectDetails) {
        existingFiles = data.getProjectAndReconConfigDetails.projectDetails.fileMatchIds;
    }

    /* function to navigate to Data Relationship page */
    const navigateToRelationshipPage = async () => {
        const oldFiles = existingFiles && existingFiles.sort();
        const newFiles = selection && selection.sort();
        const checkArr = isEqual(oldFiles, newFiles);
        if (!checkArr) {
            await runFileMatch({
                variables: {
                    input: {
                        projectId: parseInt(project.projectId, 10),
                        fileIdArr: selection,
                    },
                },
            }).then(() => {
                history.push({
                    pathname: '/relations',
                    state: {
                        projectId: projectDetails.projectId,
                        tenantId,
                        project,
                    },
                });
            });
        } else {
            history.push({
                pathname: '/relations',
                state: {
                    projectId: projectDetails.projectId,
                    tenantId,
                    project,
                },
            });
        }
    };

    const toggleSelection = key => {
        let tempSelection = [...selection];
        const keyIndex = tempSelection.indexOf(key);
        if (keyIndex >= 0) {
            tempSelection = [
                ...tempSelection.slice(0, keyIndex),
                ...tempSelection.slice(keyIndex + 1),
            ];
        } else {
            tempSelection.push(key);
        }
        setSelection(tempSelection);
    };

    const toggleAll = () => {
        const tempSelectAll = !selectAll;
        const tempSelection = [];
        if (tempSelectAll) {
            const wrappedInstance = selectTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                if (item._original) {
                    tempSelection.push(item._original.fileId);
                }
            });
        }
        setSelection(tempSelection);
        setSelectAll(tempSelectAll);
    };

    const isSelected = key => selection.includes(key);

    const extraProps = {
        selectAll,
        isSelected,
        toggleAll,
        toggleSelection,
        selectType,
        keyField,
    };

    /* function to navigate to Data Quality dashboard */
    const navigateToQualityDashboard = rowData => {
        const encodedFileName = encodeURIComponent(rowData.fileName);
        const encodedFileDisplayName = encodeURIComponent(rowData.fileDisplayName);
        const encodedTenantId = encodeURIComponent(tenantId);
        const encodedProject = encodeURIComponent(JSON.stringify(project));
        const routeTo = `/data-quality?file=${encodedFileName}&tenantId=${encodedTenantId}&project=${encodedProject}&fileDisplayName=${encodedFileDisplayName}`;
        window.open(routeTo);
    };

    /* List of columns of table showing uploaded file details */
    const fileUploadResultColumns = [
        {
            Header: 'File Name',
            accessor: 'fileDisplayName',
            minWidth: 150,
            resizable: true,
        },
        {
            Header: 'Records',
            accessor: 'noOfRecords',
            minWidth: 70,
            resizable: true,
        },
        {
            Header: 'Columns',
            accessor: 'noOfColumns',
            minWidth: 70,
            resizable: true,
        },
        {
            Header: 'DQ Score (%)',
            accessor: 'DQScore',
            minWidth: 70,
            resizable: true,
        },
        {
            Header: 'Actions',
            accessor: '',
            disableSortBy: true,
            resizable: true,
            minWidth: 70,
            style: { lineHeight: '1.25rem' },
            Cell: ({ original }) => (
                <div className="tooltip-container">
                    <Tooltip
                        content="Review Data Quality"
                        placement="left"
                        tooltipTheme="light"
                        trigger="hover"
                    >
                        <span
                            className="appkiticon a-font-24 icon-data-fill"
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigateToQualityDashboard(original)}
                            role="presentation"
                        />
                    </Tooltip>
                    <Tooltip
                        content="Delete"
                        placement="right"
                        tooltipTheme="light"
                        trigger="hover"
                    >
                        <DeleteReconFileInfo
                            projectId={projectDetails.projectId}
                            fileId={original.fileId}
                            uploadId={data.getProjectAndReconConfigDetails.uploadId}
                            refetch={refetch}
                            setToastMessage={setToastMessage}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];

    if (users.loading || loading) {
        return <Loader />;
    }

    if (users.error || error) {
        return <ErrorView />;
    }

    const getStatus = () => {
        let status;
        if (projectDetails?.status === 'open') {
            status = 'Open';
        } else if (projectDetails?.status === 'resolved') {
            status = 'Resolved';
        } else {
            status = 'Open';
        }
        return status;
    };
    return (
        <div>

            <div className="page-layout">
                <div className="project-column-2">
                    <Breadcrumb items={items} />

                    {toastMessage
                        && (
                            <DefaultAlert
                                status="success"
                                toastMessage={toastMessage}
                                setToastMessage={setToastMessage}
                            />
                        )}

                    <div className="a-h3 title-label">
                        <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => navigateToProjects()} role="presentation" />
                        {projectDetails && projectDetails.projectName}
                        {' '}
                        Details
                    </div>
                    <div>
                        <Panel
                            title="PROJECT DETAILS"
                            className="a-increase-child-color-level-by-1"
                        >
                            <Row>
                                <Col md={6}>
                                    <Row className="row-margin">
                                        <Col md={3} className="a-h6">
                                            ID
                                            <span className="label">:</span>
                                        </Col>
                                        <Col md={8}>
                                            {projectDetails && projectDetails.projectId}
                                        </Col>
                                    </Row>
                                    <Row className="row-margin">
                                        <Col md={3} className="a-h6">
                                            Project name
                                            <span className="label">:</span>
                                        </Col>
                                        <Col md={8}>
                                            {projectDetails && projectDetails.projectName}
                                        </Col>
                                    </Row>
                                    <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                                        <Col md={3} className="a-h6">
                                            Description
                                            <span className="label">:</span>
                                        </Col>
                                        <Col md={8}>
                                            {projectDetails && projectDetails.projectDesc}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={6}>
                                    <Row className="row-margin">
                                        <Col md={3} className="a-h6">
                                            Project owner
                                            <span className="label">:</span>
                                        </Col>
                                        <Col md={8}>
                                            {projectDetails && projectDetails.ownerName}
                                        </Col>
                                    </Row>
                                    <Row className="row-margin">
                                        <Col md={3} className="a-h6">
                                            Status
                                            <span className="label">:</span>
                                        </Col>
                                        <Col md={8}>
                                            {!showStatusDropdown && (
                                                <span>
                                                    {getStatus()}
                                                </span>
                                            )}
                                            {!showStatusDropdown && (
                                                <span
                                                    className="appkiticon icon-pencil-fill update-status"
                                                    style={{ color: 'black' }}
                                                    onClick={() => { setShowStatusDropdown(true); }}
                                                    role="presentation"
                                                />
                                            )}

                                            {showStatusDropdown
                                                && (
                                                    <UpdateStatus
                                                        setShowStatusDropdown={setShowStatusDropdown}
                                                        tenantId={tenantId}
                                                        project={projectDetails}
                                                        refetch={refetch}
                                                        setToastMessage={setToastMessage}
                                                    />
                                                )}
                                        </Col>
                                    </Row>
                                    <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                                        <Col md={3} className="a-h6">
                                            Project users
                                            <span className="label">:</span>
                                        </Col>
                                        <Col md={8}>
                                            {!showUsersDropdown && (
                                                <span>
                                                    {getUserName(projectDetails && projectDetails.userIdArr)}
                                                </span>
                                            )}
                                            {!showUsersDropdown && (
                                                <span
                                                    className="appkiticon icon-pencil-fill update-status"
                                                    style={{ color: 'black' }}
                                                    onClick={() => { setShowUsersDropdown(true); }}
                                                    role="presentation"
                                                />
                                            )}

                                            {showUsersDropdown
                                                && (
                                                    <UpdateProjectUsers
                                                        setShowUsersDropdown={setShowUsersDropdown}
                                                        tenantId={tenantId}
                                                        project={projectDetails}
                                                        refetch={refetch}
                                                        setToastMessage={setToastMessage}
                                                    />
                                                )}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Panel>
                    </div>
                    <div className="upload-page-panel_layout">
                        {showAddFilesModal
                            && (
                                <AddFilesToProjectModal
                                    visible={showAddFilesModal}
                                    setVisible={setShowAddFilesModal}
                                    projectId={projectDetails && projectDetails.projectId}
                                    tenantId={tenantId}
                                    refetch={refetch}
                                    setToastMessage={setToastMessage}
                                />
                            )}
                        <Panel
                            title="PROJECT FILES"
                        >
                            <div style={{ backgroundColor: '#f2f2f2', padding: '1rem', marginTop: '1rem' }}>
                                <SelectTable
                                    data={fileUploadResult}
                                    ref={r => (selectTable = r)}
                                    columns={fileUploadResultColumns}
                                    showPagination
                                    defaultPageSize={10}
                                    sortable={false}
                                    resizable={false}
                                    striped={false}
                                    getTrProps={() => ({
                                        className: 'a-file-explorer-row-color',
                                    })}
                                    getTheadProps={() => ({
                                        className: 'a-apply-theme-background-gray-level-1',
                                    })}
                                    // eslint-disable-next-line react/jsx-props-no-spreading
                                    {...extraProps}
                                />
                            </div>
                            <div style={{ marginLeft: 'auto', width: 'fit-content' }}>
                                <Button
                                    className="a-btn a-btn-transparent a-btn-lg config-btn"
                                    kind="transparent"
                                    size="lg"
                                    onClick={() => navigateToConfigPage()}
                                    style={{ marginRight: '2rem' }}
                                    disabled={!fileUploadResult || (fileUploadResult && fileUploadResult.length === 0)}
                                >
                                    SETUP DATA CONFIGURATION
                                </Button>
                                <Tooltip
                                    content="Select 2 or 3 files to enable Show Predictions"
                                    placement="left-start"
                                    tooltipTheme="light"
                                    disabled={selection.length === 2 || selection.length === 3}
                                    refStyle={{ display: 'inline-block' }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Button
                                        className="a-btn a-btn-secondary a-btn-lg config-btn"
                                        kind="secondary"
                                        size="lg"
                                        onClick={() => navigateToRelationshipPage()}
                                        disabled={(selection.length < 2 || selection.length > 3)}
                                        style={{ marginRight: '2rem' }}
                                        isLoading={runFileMatchLoading}
                                    >
                                        SHOW PREDICTIONS
                                    </Button>
                                </Tooltip>

                                <Button
                                    className="a-btn a-btn-primary a-btn-lg config-btn"
                                    kind="primary"
                                    size="lg"
                                    onClick={() => setShowAddFilesModal(true)}
                                >
                                    FILE EXPLORER
                                </Button>
                            </div>
                        </Panel>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataLineageUpload;
